import * as actionType from '../actions/actionTypes';

const chapterContent = (state = {bookContent: []}, action) => {
    switch (action.type) {
        case actionType.CHAPTER_CONTENT_LOADED_SUCCESS:
            let object = {};
            let itemLink = action.item.item_exec_file;
            object.key = itemLink;
            const {item_id, nodeId, courseId} = action.item;
            let itemViewLink;
            if (item_id === undefined && nodeId === undefined && courseId === undefined) {
                itemViewLink = [0, 0, 0];
            } else {
                itemViewLink = [parseInt(courseId), nodeId, item_id];
            }
            object.itemViewLink = itemViewLink;
            object.item = action.item;
            let item = state.bookContent.filter(chapter => chapter.key === itemLink)[0];
            if (item) {
                return {...state};
            }
            if (action.item.item_exec_file.includes('problem')) {
            } else {

            }
            let explodedLink = itemLink.split("/");
            explodedLink.pop();

            let newLink = explodedLink.join("/") + "/";
            let link = itemLink.split('/');
            let animLink = link.splice(0, link.length - 3);
            let iframAddress = animLink.join("/") + "/common/";

            let formatedHtml = process(action.content);
            // let siteLink = "https://mbook.kz";
            let siteLink = "";
            let neededLink = newLink.replace("/media", "");
            let backblazeTest = 'https://f000.backblazeb2.com/file/evero-res-books' + neededLink;
            let mainLink = formatedHtml.replace(new RegExp(backblazeTest, 'g'), function (match) {
                return "";
            });
            newLink = siteLink + newLink;
            let css = mainLink.replace(/<link.+href=["|'](?!https?:\/\/)([^\/].+?)["|']/g, `<link href='${newLink}$1'`);
            let script = css.replace(/<script.+src=["|'](?!https?:\/\/)([^\/].+?)["|']/g, `<script src='${newLink}$1' `);
            let imageString = script.replace(/<img.+src=["|'](?!https?:\/\/)([^\/].+?)["|']/g, `<img src="${newLink}$1"`);
            let imageUpperCaseString = imageString.replace(/<IMG.+SRC=["|'](?!https?:\/\/)([^\/].+?)["|']/g, `<img src="${newLink}$1"s`);
            let screen = imageUpperCaseString.replace("media=\"screen\"", "");
            let iframe = screen.replace(/<iframe.+src=["|'](?!https?:\/\/)([^\/].+?)["|']/g, function (match) {
                let animLink = match.split("../").join("").split("common/").join("");
                let animationLink = animLink.replace(/<iframe.+src=["|'](?!https?:\/\/)([^\/].+?)["|']/g, `<iframe src='${siteLink}$1'`);
                return animationLink;
            });
            let closeBody = iframe.replace(/<\/body>/g, "") + "</body>";
            let finalLink = closeBody.toString().replace(/<\/html>/g, "") + "</html>";
            if (!finalLink.includes("<html>")) {
                finalLink = "<html>" + finalLink;
            }
            object.content = finalLink;
            return {...state, bookContent: state.bookContent.concat(object)};
        case actionType.CHAPTER_CONTENT_LOADED_FAILED:
            break;
        default:
            return state;
    }
};

function process(str) {

    let div = document.createElement('div');
    div.innerHTML = str.trim();

    return format(div, 0).innerHTML;
}

function format(node, level) {

    let indentBefore = new Array(level++ + 1).join('  '),
        indentAfter = new Array(level - 1).join('  '),
        textNode;

    for (let i = 0; i < node.children.length; i++) {

        textNode = document.createTextNode('\n' + indentBefore);
        node.insertBefore(textNode, node.children[i]);

        format(node.children[i], level);

        if (node.lastElementChild === node.children[i]) {
            textNode = document.createTextNode('\n' + indentAfter);
            node.appendChild(textNode);
        }
    }

    return node;
}

export default chapterContent;





// WEBPACK FOOTER //
// ./src/reducers/chapterContent.js